const rankings = [
  {
    rank: 1,
    change: "up",
    title: "某顶流被曝隐婚生子，当事人尚未回应",
    heat: "98.7万",
    tag: "爆料",
  },
  {
    rank: 2,
    change: "same",
    title: "综艺录制现场突发意外，导演组紧急处理中",
    heat: "87.3万",
    tag: "话题",
  },
  {
    rank: 3,
    change: "up",
    title: "本周擦边搞笑内容合集TOP20，笑到肚子疼",
    heat: "76.5万",
    tag: "搞笑",
  },
  {
    rank: 4,
    change: "down",
    title: "某网红直播翻车后续：品牌方集体解约",
    heat: "65.2万",
    tag: "黑料",
  },
  {
    rank: 5,
    change: "up",
    title: "业内人士曝某选秀节目晋级名单提前泄露",
    heat: "54.8万",
    tag: "爆料",
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            热门榜单
          </h2>
          <span className="text-xs text-foreground-400 bg-background-200/70 px-3 py-1 rounded-full whitespace-nowrap">
            实时更新
          </span>
        </div>
        <div className="bg-background-50 rounded-2xl overflow-hidden">
          {rankings.map((item, i) => (
            <a
              key={i}
              href="#about"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-primary-50/30 transition-colors duration-200 cursor-pointer ${
                i < rankings.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-xl text-sm font-heading ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-800 leading-relaxed line-clamp-1">{item.title}</p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs font-medium px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">{item.tag}</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}热度</span>
                </div>
              </div>
              <div className="flex-shrink-0">
                {item.change === 'up' && (
                  <div className="w-6 h-6 flex items-center justify-center text-accent-500">
                    <i className="ri-arrow-up-fill text-lg"></i>
                  </div>
                )}
                {item.change === 'down' && (
                  <div className="w-6 h-6 flex items-center justify-center text-foreground-400">
                    <i className="ri-arrow-down-fill text-lg"></i>
                  </div>
                )}
                {item.change === 'same' && (
                  <div className="w-6 h-6 flex items-center justify-center text-foreground-300">
                    <i className="ri-subtract-line text-lg"></i>
                  </div>
                )}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}